import { LoadingState } from '@lcs/shared/api';
import { createFeatureSelector, on } from '@ngrx/store';
import { OrderingDirections } from 'generated/graphql-types';
import { RegisterState } from 'src/app/common-components/register/models/register-state';
import {
   RegisterAdapter,
   createRegisterAdapter,
} from 'src/app/common-components/register/models/register-state.adapter';
import { SchedulesFilterOption } from '../models/schedule-filter-option';
import { ScheduleOrderingOptions, ScheduleRegisterOptions } from '../models/schedule-register-options';
import { ScheduleRegisterListItem } from '../models/schedule-register-results.model';
import * as scheduleRegisterActions from './schedule-register.actions';

export const scheduleRegisterFeatureKey = 'scheduleRegister';

export interface ScheduleRegisterState
   extends RegisterState<ScheduleRegisterListItem, ScheduleRegisterOptions, ScheduleOrderingOptions> {
   filters: SchedulesFilterOption[];
}

const adapter: RegisterAdapter<ScheduleRegisterListItem, ScheduleRegisterOptions, ScheduleOrderingOptions> =
   createRegisterAdapter<ScheduleRegisterListItem, ScheduleRegisterOptions, ScheduleOrderingOptions>({
      selectId: (scheduleRegisterItem) => {
         return scheduleRegisterItem.scheduleId ?? 0;
      },
   });

export const initialState: ScheduleRegisterState = {
   ...adapter.getInitialState(),
   filters: [],
   orderingOptions: [{ direction: OrderingDirections.Asc, field: 'name' }],
};

export const scheduleRegisterReducer = adapter.createReducer(
   scheduleRegisterActions.scheduleRegisterAdapterActions,
   initialState,
   on(scheduleRegisterActions.scheduleRegisterAdapterActions.pageEnter, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(scheduleRegisterActions.scheduleRegisterAdapterActions.loadSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         endCursor: action.endCursor,
         hasNextPage: action.hasNextPage,
         schedule: action.items,
         totalCount: action.totalCount,
      };
   }),
   on(scheduleRegisterActions.scheduleRegisterAdapterActions.quickFilterChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         quickFilters: {
            ...state.quickFilters,
            ...action.quickFilters,
         },
      };
   }),
   on(scheduleRegisterActions.scheduleRegisterInitialFilter, (state, action) => {
      return {
         ...state,
         filters: action.filters,
      };
   }),
   on(scheduleRegisterActions.scheduleRegisterAdapterActions.orderingOptionsChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         orderingOptions: action.orderingOptions,
      };
   }),
   on(scheduleRegisterActions.loadingUrlParams, (state) => ({
      ...state,
      callState: LoadingState.Loading,
   })),
   on(scheduleRegisterActions.loadedUrlParams, (state, action) => ({
      ...state,
      callState: LoadingState.Loaded,
      selectedId: action.scheduleId,
   }))
);
export const scheduleRegisterSelector = createFeatureSelector<ScheduleRegisterState>(scheduleRegisterFeatureKey);
export const selectors = adapter.getSelectors(scheduleRegisterSelector);
export const {
   selectAll,
   selectCallState,
   selectTotalCount,
   selectQuickFilters,
   selectEndCursor,
   selectOrderingOptions,
} = adapter.getSelectors(scheduleRegisterSelector);
